import PropTypes from 'prop-types'

// it doesnt complain where it is consumed so I am leaving it empty for now at least,
// since it is a third party library
export const formikPropType = PropTypes.shape({})
